import { resetAndAddClass } from './resetAndAddClass.js'

export const closeAllChannels = () => {
  resetAndAddClass('.cce-widget__window__container', ['cce-widget__window__container'])
  resetAndAddClass('.cce-widget__window__header', ['cce-widget__window__header'])
  resetAndAddClass('.cce-widget__window__footer__menu__option', ['cce-widget__window__footer__menu__option'])
  resetAndAddClass('.cce-widget__window__header--back', ['cce-widget__window__header--back'])
  resetAndAddClass('.cce-widget-chat', ['cce-widget-chat'])
  resetAndAddClass('.cce-widget-faq', ['cce-widget-faq'])
  resetAndAddClass('.cce-widget-audio', ['cce-widget-audio', 'initiated'])
  resetAndAddClass('.cce-widget-video', ['cce-widget-video', 'initiated'])
  resetAndAddClass('.cce-widget-callback', ['cce-widget-callback'])
  resetAndAddClass('.cce-widget-whatsapp', ['cce-widget-whatsapp'])
  resetAndAddClass('.cce-widget-scheduledVideo', ['cce-widget-scheduledVideo'])
  resetAndAddClass('.cce-widget-facebookMessenger', ['cce-widget-facebookMessenger'])
  resetAndAddClass('.cce-widget__bubble', ['cce-widget__bubble', 'cce-widget__bubble--visible'])
}

